<div class="advertisement_card border_radius_2 border_solid_2 overflow-hidden h-100">
    <a
        [queryParams]="{view: SubmitView ? true : null}"
        [routerLink]="['/realty-management/view-realty-advertisement' , Data.id]" 
        class="advertisement_card_link d-flex justify-content-center align-items-stretch h-100 flex-wrap a_none"
    >
        <div class="graph_side align-self-center border_solid border_radius_2 overflow-hidden position-relative" [class.available]="Data.available">
            <img 
                appImgUrlCheck
                loading="lazy"
                class="img-fluid" 
                [alt]="CardTitle"
                [src]="CardImage"
            />
            <ng-container *ngIf="IsOffPlanSale && Data.available">
                <div #ProgressContainer class="progress_container text-center overflow-hidden">
                    <div [class]="CardProgress < 100 ? 'text-black' : 'text-white'" class="progress_texts font_16 font_700">
                        <ng-container *ngIf="CardProgress < 100; else CompletedTemp">
                            <ng-container *ngFor="let char of SplitTexts; let i = index">
                                <span 
                                    #ProgressChar
                                    class="split_text d-inline"
                                    [class.float-end]="i >= SplitTexts.length - (CardProgress.toString().length > 1 ? 4 : 2)"
                                >{{char}}</span>
                            </ng-container>
                        </ng-container>
                    </div>
                    <div #ProgressBar class="progress_bar" [ngStyle]="{'width': CardProgress + '%'}"></div>
                    <ng-template #CompletedTemp>
                        <span class="margin_end">100%</span>
                        <i class="fa-solid fa-circle-check"></i>
                    </ng-template>
                </div>
            </ng-container>
        </div>
        <div class="data_side d-flex flex-column justify-content-between flex-grow-1">
            <div class="d-flex justify-content-between align-items-center">
                <h5 class="float-start font_20 font_700 main_color_4th mb-0">{{CardTitle}}</h5>
                <div class="advertisement_badge float-end text-white font_14 font_600 border_radius_2">{{CardSubCategoryTitle}}</div>
            </div>
            <div class="location">
                <span class="margin_end_2">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M23.943 16.846L12 24.012L0.0570068 16.846L5.72101 13.448L7.19901 14.893L3.94401 16.846L12.001 21.68L20.058 16.846L16.802 14.893L18.28 13.448L23.945 16.847L23.943 16.846ZM7.05801 11.958C4.32201 9.22101 4.32201 4.78001 7.05001 2.05101C8.37201 0.729007 10.131 0.00100708 12 0.00100708C13.869 0.00100708 15.628 0.729007 16.949 2.05101C18.271 3.37301 19 5.13101 19 7.00101C19 8.87101 18.271 10.628 16.949 11.951L12 16.792L7.05801 11.958ZM8.46401 10.536L12 13.994L15.543 10.528C16.48 9.59101 17 8.33601 17 7.00001C17 5.66401 16.479 4.40901 15.535 3.46401C14.591 2.51901 13.336 2.00001 12 2.00001C10.664 2.00001 9.40801 2.52001 8.46401 3.46401C6.51501 5.41401 6.51501 8.58601 8.46401 10.535V10.536ZM12 9.99101C13.657 9.99101 15 8.64801 15 6.99101C15 5.33401 13.657 3.99101 12 3.99101C10.343 3.99101 9.00001 5.33401 9.00001 6.99101C9.00001 8.64801 10.343 9.99101 12 9.99101Z" fill="#AFAFAF"/>
                    </svg>
                </span>
                <span class="font_14 font_500 color_gray">{{CardLocationZone}}</span>
            </div>
            <ng-container *ngIf="CardBedrooms != null">
                <div class="font_16 font_500 color_gray">
                    <span class="d-inline-block margin_end">عدد الغرف : </span>
                    <span class="font_600 font_14 main_color_4th">{{CardBedrooms}}</span>
                </div>
            </ng-container>
            <ng-container *ngIf="IsHasBundledAds">
                <div class="bundled_advertisements_units_title d-flex align-items-center flex-wrap font_16 font_500 color_gray">
                    <div class="margin_end_4">
                        <span class="d-inline-block margin_end">{{BundledAdvertisementUnitsTitle.total}} : </span>
                        <span class="font_600 font_14 main_color_4th">{{Data.unitsCount}}</span>
                    </div>
                    <div>
                        <span class="d-inline-block margin_end">{{BundledAdvertisementUnitsTitle.available}} : </span>
                        <span class="font_600 font_14 main_color_4th">{{Data.availableUnitsCount}}</span>
                    </div>                
                </div>
            </ng-container>
            <div class="advertisement_size font_16 font_500 color_gray">
                <span class="d-inline-block margin_end">{{(Data.size | SizeHandler : CategoryType)?.title}} : </span>
                <span class="font_600 font_14 main_color_4th">{{(Data.size | SizeHandler : CategoryType)?.value + '  م2 '}}</span>
            </div>
            <div class="d-flex justify-content-between align-items-end">
                <div class="advertisement_price">
                    <span class="d-block font_16 font_500 color_gray">{{(Data | PriceHandler)?.title}} : </span>
                    <span class="font_700 font_20 margin_end">{{(Data | PriceHandler)?.value}}</span>
                    <span class="font_16 font_500 color_gray">ريال</span>
                </div>
                <div appStopPropagation class="options d-flex justify-content-between align-items-center">
                    <ng-container *ngIf="Card3DModel != null">
                        <a target="_blank" [href]="Card3DModel" class="advertisement_3d a_none">
                            <app-virtual-icon />
                        </a>
                    </ng-container>
                    <ng-container *ngIf="!CardOwner">
                        <div appPreventDefault class="advertisement_comment" [class.margin_start_7]="Card3DModel != null" (click)="HandlerSendContactRequest()" >
                            <app-chat-icon />
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </a>
</div>